export function isFirebaseIndexedDbClosingError(error) {
  if (!error) return false;

  const message = error.message || String(error);

  return (
    error.name === "InvalidStateError" ||
    message.includes("database connection is closing")
  );
}

export function isBenignFirebaseSignOutError(error) {
  return isFirebaseIndexedDbClosingError(error);
}
